import { commandApi } from './commandApi';

const GET_CONTENT_URL_COMMAND = 'get-context-notification';
const REGISTER_POPUP_STATE_COMMAND = 'save-context-notification-status';

export class InformationPopupApi {
  
  /**
   * @param {INFORMATION_POPUP_CONTEXT_CODES} code
   * @return {Promise<InformationPopupDataModel>}
   */
  getContentUrl(code) {
    return commandApi.send(GET_CONTENT_URL_COMMAND, { code });
  }
  
  /**
   *
   * @param {InformationPopupDataModel} model
   * @return {Promise<*>}
   */
  savePopupStatus(model) {
    return commandApi.send(REGISTER_POPUP_STATE_COMMAND, model);
  }
  
}
export const informationPopupApi = new InformationPopupApi();
